(() => {
    const mountStickyFilter = () => {
        // Target element
        const target = document.querySelector('menu-drawer.mobile-facets__wrapper');
        const header = document.querySelector('main#MainContent');
        const stickyFilter = target?.querySelector('summary.mobile-facets__open-wrapper')

        if (target && header && stickyFilter) {
            // Cache positions once
            const targetTop = target.offsetTop;
            const headerHeight = header.offsetTop;
            const buffer = 50; // extra pixels to trigger earlier

            // Apply sticky filter offset
            stickyFilter.style.top = `${headerHeight}px`;

            // Scroll handler
            const handleScroll = () => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                target.classList.toggle('scrolled-past', scrollTop + headerHeight + buffer > targetTop);
            };

            // Attach debounced scroll listener
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('beforeunload', () => {
                window.removeEventListener('scroll', handleScroll);
            });
        }
    }

    // Use requestIdleCallback to clean up event listener when idle
    if ('requestIdleCallback' in window) requestIdleCallback(mountStickyFilter);
    else setTimeout(mountStickyFilter, 100);
})()